(() => {
  const form = document.querySelector('#ua-promo-newsletter');
  if (!form || !window.fetch) return;

  const feedback = form.querySelector('[data-ua-promo-signup-feedback]');
  const verification = form.querySelector('[data-ua-promo-verification]');
  const button = form.querySelector('[type="submit"]');
  const email = form.querySelector('[name="contact[email]"]');
  let pending = false;
  let subscribed = false;

  const message = (text, state) => {
    feedback.textContent = text;
    feedback.dataset.state = state;
    feedback.setAttribute('role', state === 'error' ? 'alert' : 'status');
  };

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending || subscribed || !form.reportValidity()) return;
    pending = true;
    button.disabled = true;
    form.setAttribute('aria-busy', 'true');
    email.removeAttribute('aria-invalid');
    verification.hidden = true;
    message(feedback.dataset.pending, 'pending');

    try {
      const captcha = window.Shopify?.captcha;
      if (captcha?.protect) {
        await new Promise((resolve, reject) => {
          const timeout = window.setTimeout(() => reject(new Error('Verification unavailable')), 15000);
          captcha.protect(form, () => { window.clearTimeout(timeout); resolve(); });
        });
      }

      const response = await window.fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: { Accept: 'text/html' },
      });
      const url = new URL(response.url || form.action, window.location.href);
      if (/\/challenge\/?$/.test(url.pathname) && url.origin === window.location.origin) {
        verification.href = url.href;
        verification.hidden = false;
        message(feedback.dataset.verification, 'error');
        return;
      }

      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const result = html.querySelector('#ua-promo-newsletter [data-ua-promo-signup-feedback]');
      if (result?.dataset.state === 'error') {
        email.setAttribute('aria-invalid', 'true');
        message(result.textContent.trim() || feedback.dataset.error, 'error');
      } else if (response.ok && (result?.dataset.state === 'success' || url.searchParams.get('customer_posted') === 'true')) {
        subscribed = true;
        message(feedback.dataset.success, 'success');
        form.reset();
      } else {
        message(feedback.dataset.error, 'error');
      }
    } catch {
      message(feedback.dataset.error, 'error');
    } finally {
      pending = false;
      button.disabled = subscribed;
      form.removeAttribute('aria-busy');
    }
  });
})();
